var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Box, FormControlLabel, Checkbox } from '@mui/material';
import { RequerentePf } from "../../../../model/RequerentePf";
import { useRequerimentoContext } from "../context/RequerimentoContext";
import React from "react";
export default function PossuiProcurador() {
    var _a = useRequerimentoContext(), indicarProcurador = _a.indicarProcurador, setIndicarProcurador = _a.setIndicarProcurador, _requerimento = _a._requerimento;
    var setRequerimento = _requerimento[1];
    var handleChange = function (event) {
        setIndicarProcurador(event.target.checked);
        setRequerimento(function (prevState) { return (__assign(__assign({}, prevState), { procurador: __assign(__assign({}, prevState.procurador), { pessoaFisica: new RequerentePf() }) })); });
    };
    return (_jsx(Box, __assign({ sx: { textAlign: 'left', p: 0, background: 'transparent' } }, { children: _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: indicarProcurador, onChange: handleChange }), label: "Desejo indicar um procurador para futuro acesso ao requerimento" }) })));
}
